import { render, staticRenderFns } from "./StarSpecialist.vue?vue&type=template&id=11e2db44&scoped=true&"
import script from "./StarSpecialist.vue?vue&type=script&lang=js&"
export * from "./StarSpecialist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e2db44",
  null
  
)

export default component.exports